import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getActivitySkills } from '../../actions';
import { getAllSkills, getAllSkillGroups } from '../../actions/skills';
import { getSkill } from '../../actions';
import ActivitySkills from './ActivitySkills';
import { getSkillTypeName } from '../../constants/skillTypes.js'

class ActivitySkillsContainer extends Component {
    componentDidMount() {
        const { scene } = this.props;
        this.props.getActivitySkills(scene);
        this.props.getAllSkills();
        this.props.getAllSkillGroups();
    }

    formatSkill(item) {
        const { skillGroups, allSkills } = this.props;
        var skill = {};

        skill.skillId = item.skillId ? item.skillId : item.activityScoreDetailId;
        skill.skillName = item.skillName;
        skill.datasetNumber = item.datasetNumber;
        if(item.skillGroupName === undefined) {
            //This means the skill was just added, so we have to look up the group and skill type
            let foundskill = allSkills.find(el => el.skillName === item.skillName);
            skill.skillGroupName = skillGroups.find(group => group.skillGroupId === foundskill.skillGroup).skillGroupName;
            skill.skillTypeName = getSkillTypeName(foundskill.skillType);  
        }
        else {
            //if the skill was not just added, the info will just be there
            skill.skillGroupName = item.skillGroupName;
            skill.skillTypeName = item.skillTypeName;
        }
        return skill;
    }

    render () {
        const { activitySkills } = this.props;
        var displaySkills = activitySkills.map(item => {
            return this.formatSkill(item);                
        })
        return (
            <ActivitySkills skills={displaySkills}/>
        );
    }
}

ActivitySkillsContainer.propTypes =  {
    getActivitySkills: PropTypes.func.isRequired,
    scene: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    activitySkills: state.skills.activitySkills,
    allSkills: state.skills.allSkills,
    skillGroups: state.skills.skillGroups,
    scene: state.scene.current
});

const mapDispatchToProps = ({
    getActivitySkills,
    getAllSkills,
    getAllSkillGroups,
    getSkill
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActivitySkillsContainer);



// WEBPACK FOOTER //
// ./src/components/activitySkills/ActivitySkillsContainer.js